import { faBell, faCheckCircle, faSpinnerThird } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FC, HTMLProps } from "react";
import { a, useTransition } from "react-spring";

import { useSnackbar } from "./useSnackbar";

import * as styles from "./Snackbar.styles";

const Snackbar: FC<HTMLProps<HTMLDivElement>> = props => {
  const { isSnackbarOpen, status, message, position } = useSnackbar();

  const direction = position.includes("Left") ? "-80px" : "80px";

  const transitions = useTransition(isSnackbarOpen, {
    from: { transform: `translate3d(${direction}, 0,0)`, opacity: 0 },
    enter: { transform: "translate3d(0, 0,0)", opacity: 1 },
    leave: { transform: "translate3d(0, 0,0)", opacity: 0 },
  });

  const snackbarStyles = () => {
    return [styles.base, status === "success" && styles.successStatus, styles.position[position]];
  };

  const renderAnimatedDiv = elements => {
    return transitions((style, item) => {
      return (
        item && (
          <a.div style={style} css={snackbarStyles()}>
            {elements}
          </a.div>
        )
      );
    });
  };

  const renderIcon = () => {
    if (status === "normal") {
      return <FontAwesomeIcon size="sm" icon={faBell} css={styles.spinner} />;
    }
    if (status === "loading") {
      return <FontAwesomeIcon size="sm" spin icon={faSpinnerThird} css={styles.spinner} />;
    }
    if (status === "success") {
      return <FontAwesomeIcon size="sm" icon={faCheckCircle} css={styles.spinner} />;
    }
  };

  return (
    <>
      {renderAnimatedDiv(
        <div {...props} data-testid="snackbar-wrapper">
          {renderIcon()}
          {message}
        </div>
      )}
    </>
  );
};

export { Snackbar };
